import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function External({ color, size }: IIconProps): ReactElement {
  const dimension = size ?? 12;

  return (
    <svg
      width={dimension}
      height={dimension}
      viewBox="118.25 2.25 11.5 11.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M121.5 2.25C121.914 2.25 122.25 2.58579 122.25 3C122.25 3.41421 121.914 3.75 121.5 3.75H120C119.862 3.75 119.75 3.86193 119.75 4V12C119.75 12.1381 119.862 12.25 120 12.25H128C128.138 12.25 128.25 12.1381 128.25 12V10.5C128.25 10.0858 128.586 9.75 129 9.75C129.414 9.75 129.75 10.0858 129.75 10.5V12C129.75 12.9665 128.967 13.75 128 13.75H120C119.034 13.75 118.25 12.9665 118.25 12V4C118.25 3.0335 119.034 2.25 120 2.25H121.5Z"
        fill={color || "#509ee3"}
      />
      <path
        d="M129 2.25C129.102 2.25 129.199 2.26999 129.287 2.30664C129.376 2.34324 129.458 2.39782 129.53 2.46973C129.602 2.54163 129.657 2.62444 129.693 2.71289C129.73 2.8013 129.75 2.89834 129.75 3V7C129.75 7.41421 129.414 7.75 129 7.75C128.586 7.75 128.25 7.41421 128.25 7V4.81055L125.03 8.03027C124.737 8.32316 124.263 8.32316 123.97 8.03027C123.677 7.73738 123.677 7.26262 123.97 6.96973L127.189 3.75H125C124.586 3.75 124.25 3.41421 124.25 3C124.25 2.58579 124.586 2.25 125 2.25H129Z"
        fill={color || "#509ee3"}
      />
    </svg>
  );
}
